import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setCurrentWorkspaceDevicesIds } from '../slices/currentWorkspace';
import { setDevices, setUpdateDevicePlaceOpen } from '../slices/devices';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';

export const getDevicesByWorkspace = createAsyncThunk(
  'devices/getDevicesByWorkspace',
  async (payload, { dispatch }) => {
    const { workspaceId } = payload;
    if (!_.isEmpty(workspaceId)) {
      const workspaceDevices = await api.workspace.getDevicesByWorkspace({
        workspaceId,
      });

      dispatch(setDevices(workspaceDevices.data.getDevicesByWorkspace.devices));

      dispatch(
        setCurrentWorkspaceDevicesIds(
          workspaceDevices.data.getDevicesByWorkspace.devices.map(
            (device) => device.id
          )
        )
      );
    } else {
      throw new Error('generalError'); // to prevent the slice acting as fulfilled
    }
  }
);

export const getDevicesByCustomerId = createAsyncThunk(
  'devices/getDevicesByCustomerId',
  async (customerId) => {
    const response = await api.device.getDevicesByCustomerId({
      customerId,
    });
    return response.data.getDevicesByCustomer;
  }
);

export const getDevicesByCustomerIds = createAsyncThunk(
  'devices/getDevicesByCustomerIds',
  async (payload) => {
    const { customerIds } = payload;
    const response = await api.device.getDevicesByCustomerIds({
      customerIds,
    });

    return response.data.getDevicesByCustomers;
  }
);
export const getDeviceById = createAsyncThunk(
  'devices/getDeviceById',
  async (payload) => {
    const { id } = payload;

    const response = await api.device.getDeviceById({ id });

    return response.data.getDeviceById;
  }
);

export const getDevicesByIds = createAsyncThunk(
  'devices/getDevicesByIds',
  async (payload) => {
    const { deviceIds } = payload;

    const response = await api.device.getDevicesByIds({ deviceIds });

    return response.data.getDevicesByIds;
  }
);

export const updateDeviceById = createAsyncThunk(
  'devices/updateDeviceById',
  async (payload, { dispatch, getState }) => {
    const { deviceId, data } = payload;
    const deviceUpdated = await api.device.updateDeviceById({
      id: deviceId,
      data,
    });

    const state = getState();
    const currentWorkspaceId = state.currentWorkspace?.workspace?.id;
    if (currentWorkspaceId) {
      dispatch(getDevicesByWorkspace({ workspaceId: currentWorkspaceId }));
    }

    return deviceUpdated.data.updateDeviceById;
  }
);

export const deleteDeviceById = createAsyncThunk(
  'devices/deleteDeviceById',
  async (payload, { dispatch, getState }) => {
    const { id } = payload;
    const deviceDeleted = await api.device.deleteDeviceById({
      id,
    });

    const state = getState();
    const currentWorkspaceId = state.currentWorkspace?.workspace?.id;
    if (currentWorkspaceId) {
      dispatch(getDevicesByWorkspace({ workspaceId: currentWorkspaceId }));
    }

    return deviceDeleted.data.deleteDeviceById;
  }
);
export const setUpdateDevicePlaceById = createAsyncThunk(
  'devices/updateDevicePlaceByDeviceId',
  async (payload, { dispatch }) => {
    const { id } = payload;
    if (!_.isEmpty(id)) {
      try {
        await api.device.setDevicePlaceOpened({ deviceId: id });
        dispatch(setUpdateDevicePlaceOpen(id));
        return null;
      } catch {
        return null;
      }
    }
    return null;
  }
);

export const updateDeviceImage = createAsyncThunk(
  'devices/updateDeviceImage',
  async (payload) => {
    const { file } = payload;
    const pictureName = `${uuidv4()}.webp`;

    const { data } = await api.upload.getUploadUrl({
      filename: pictureName,
    });

    const options = {
      // maxWidthOrHeight: 200,
      useWebWorker: true,
      fileType: 'image/webp',
    };

    const compressedImage = await imageCompression(file, options);

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': compressedImage.type,
      },
      mode: 'cors',
      body: compressedImage,
    };

    const uploadToS3Response = await fetch(
      data?.getUploadSignedUrl?.url,
      requestOptions
    );

    if (uploadToS3Response.ok) {
      return pictureName;
    } else {
      throw new Error('Error uploading image');
    }
  }
);
